<template>
  <div
    id="turnstile-box"
    ref="turnstileBox"
    data-theme="light"
  />
</template>
<script>
export default {
  name: "CloudFrontVerification",
  props: {
    sitekey: {
      type: String,
      required: true
    }
  },
  mounted() {
    if (window.turnstile === null || !window.turnstile) {
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback'
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    }else{window.turnstile && window.turnstile.render("#turnstile-box", {
      sitekey: this.sitekey,
      callback: (response) => this.$emit('verify', this.verify(response)),
      'expired-callback': this.$emit('expire'),
      'error-callback': this.$emit('fail')
    })}
    this.renderTurnstile()
  },
  methods: {
    renderTurnstile() {
      window.onloadTurnstileCallback = () => {
        window.turnstile && window.turnstile.render("#turnstile-box", {
          sitekey: this.sitekey,
          callback: (response) => this.$emit('verify', response),
          'expired-callback': this.$emit('expire'),
          'error-callback': this.$emit('fail')
        })
      }
    },
    verify: (response) => {
      return response !== null && response !== "";
    },
  },
}
</script>

<style scoped lang="scss">

</style>